<h2 mat-dialog-title>{{ editing ? 'Edit account' : 'Add account' }}</h2>
<mat-dialog-content>
  @if (!editing) {
  <app-email-login-field
    [control]="emailControl"
    (loginInfoChange)="onLoginInfoChange($event)">
  </app-email-login-field>
  <p class="hint">One stock per account — adding the same email twice is a conflict. If the email has no login info yet, use "Add" to create it first.</p>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Supplier</mat-label>
    <mat-select [(ngModel)]="supplierId">
      @for (s of data.suppliers; track s.user_id) {
      <mat-option [value]="s.user_id">{{ s.name }}</mat-option>
      }
    </mat-select>
    <mat-hint>The account is owned by this supplier, not by you as its creator.</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Stop threshold (coins)</mat-label>
    <input matInput type="number" min="0" [(ngModel)]="coinsToBeRemain">
  </mat-form-field>
  }

  <mat-form-field appearance="outline" class="full">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="description">
  </mat-form-field>

  @if (error) { <p class="err">{{ error }}</p> }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="ref.close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="saving || (!editing && !selectedLoginInfo)" (click)="save()">
    {{ saving ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
